<template>
  <b-dialog
    :visible="isVisible"
    @close="close"
    class="live-warning"
  >
    <div class="warning-title">
      <template v-for="(part, $index) in warningInfo?.title">
        <text-part
          v-if="part.type !== MESSAGE_ITEM_TYPE_ICON"
          :key="`title-text-${$index}`" 
          :partData="part"
        />
        <icon-part
          v-else-if="part.type === MESSAGE_ITEM_TYPE_ICON" 
          :key="`title-icon-${$index}`"
          :partData="part"
        />
      </template>
    </div>
    <div class="warning-content">
      <template v-for="(part, $index) in warningInfo?.content">
        <text-part
          v-if="part.type !== MESSAGE_ITEM_TYPE_ICON"
          :key="`content-text-${$index}`" 
          :partData="part"
        />
        <icon-part
          v-else-if="part.type === MESSAGE_ITEM_TYPE_ICON" 
          :key="`content-icon-${$index}`"
          :partData="part"
        />
      </template>
    </div>
    <div>
      <b-button class="confirm-btn" size="large" :hollow="true" type="default" @click="close">
        {{ confirmBtnText }}
      </b-button>
    </div>
  </b-dialog>
</template>

<script lang="ts" setup>
import TextPart from '@/components/comment/comment-list/text-part';
import IconPart from '@/components/comment/comment-list/icon-part';
import { BDialog, BButton } from '@bilibili-intl/components';
import emitter, { EB_EVENT_NAME, IOpenWarningModalData } from '@/utils/eventbus';
import { computed, onMounted, ref, Ref } from 'vue';
import {
  MESSAGE_ITEM_TYPE_TEXT,
  MESSAGE_ITEM_TYPE_ICON,
} from '@/constants/comment';
import i18n from '@/locales/index';

// const roomService = new RoomService();
const $t = i18n().global.t;

const warningInfo: Ref<IOpenWarningModalData | null> = ref(null);

const isVisible:Ref<boolean> = ref(false);
const duration:Ref<number> = ref(0);
let timer: NodeJS.Timer | null  = null;


const onModalOpen = (params: IOpenWarningModalData) => {
  isVisible.value = true;
  warningInfo.value = params;
  startTimer(params.duration);
};

const confirmBtnText = computed(() => {
  if (duration.value <= 0) {
    return $t('common.confirm');
  }
  return `${$t('common.confirm')} (${duration?.value}s)`;
});

const startTimer = (newDuration: number) => {
  duration.value = newDuration;
  if (timer) {
    clearInterval(timer);
  }
  timer = setInterval(() => {
    duration.value -= 1;
    if (duration.value  <= 0 && timer) {
      clearInterval(timer);
      close();
    }
  }, 1000);
};

const close = () => {
  isVisible.value = false;
  warningInfo.value = null;
};

onMounted(() => {
  emitter.on(EB_EVENT_NAME.OPEN_WARNING_MODAL, onModalOpen);
  emitter.on(EB_EVENT_NAME.LIVE_BLOCK, close);
});

</script>


<style lang="less" scoped>
  .warning-title {
    font-size: 24px;
    display: flex;
    padding-bottom: 16px;
    line-height: 28px;
    
    .message-icon-part {
      width: 24px;
      height: 24px;
      background-size: 24px;
      background-position: center;
      margin: 2px 8px 2px 0;
    }

    .message-text-part {
      font-weight: 700;
      color: #333;
    }
  }
  .warning-content {
    display: flex;
    color: #333;
  }

  .confirm-btn {
    width: 100%;
    margin: 28px 0 36px;
  }
  
</style>
<style lang="less">
.warning-modal .dialog__container .dialog__header {
  padding-bottom: 0;
}
</style>